"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawRotatedRect = void 0;
const create_angular_coordinate_system_1 = require("./create-angular-coordinate-system");
/**
 * Draw a rotated rectangle into a canvas rendering context.
 * The caller needs to call stroke() or fill() on the canvas
 * rendering context based on whether they want to draw the
 * edges or fill in the rectangle.
 *
 * @param ctx
 * @param center
 * @param xSize
 * @param ySize
 * @param angleInRadians
 */
const drawRotatedRect = (ctx, center, xSize, ySize, angleInRadians) => {
    const coordinateSystemAtCenterOfRectangle = (0, create_angular_coordinate_system_1.createAngularCoordinateSystem)(center, angleInRadians);
    const halfXSize = xSize / 2;
    const halfYSize = ySize / 2;
    const points = [
        [-1, -1], [-1, 1], [1, 1], [1, -1]
    ].map(([xDir, yDir]) => coordinateSystemAtCenterOfRectangle.pointAtAsTuple({ x: halfXSize * xDir, y: halfYSize * yDir }));
    // Start at the last point
    ctx.moveTo(...points[3]);
    ctx.beginPath();
    // Draw a line around the rectangle starting from  point 3
    // to point 0, then to 1, then 2, then back to 3.
    points.forEach(point => ctx.lineTo(...point));
};
exports.drawRotatedRect = drawRotatedRect;
//# sourceMappingURL=draw-rotated-rect.js.map